import type { Day } from '@bp/bp-graphql-types';
import { graphql } from 'client/gql';
import dayjs from 'dayjs';
import { useQuery } from 'urql';
import { CONNECT_DATE_TEMPLATE } from '../utils/connectLib';

const DaysQueryDocument = graphql(`
  query DaysData($date: String!) {
    days(where: { date: $date }) {
      uuid
      __typename
      date
    }
  }
`);

export type DayType = Pick<Day, 'uuid' | 'date' | 'day' | 'month' | 'year' | 'dayOfWeek' | 'week' | 'schoolDay'>;

export const useDays = () => {
  const [{ data }] = useQuery({
    query: DaysQueryDocument,
    variables: {
      date: dayjs().format(CONNECT_DATE_TEMPLATE),
    },
  });

  const today = data?.days[0];

  const isFuture = (date: string | undefined | null) => dayjs(date).isAfter(today?.date, 'day');
  const isPast = (date: string | undefined | null) => dayjs(date).isBefore(today?.date, 'day');
  const daysLeft = (date: string | undefined | null, returnNegative = false): number => {
    const remaining = dayjs(date).diff(dayjs(today?.date), 'd');

    if (!returnNegative) {
      // return 0 when negative
      return remaining < 0 ? 0 : remaining;
    }

    // return any value
    return remaining;
  };

  return { today, daysLeft, isPast, isFuture };
};
